// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"2a0381e6e97ec0e7f82a","293":"8863290555dce2666d5a","466":"bd3804bcc89d5f6e0c8d"}[chunkId] + ".js";
};